import React from "react";

// Shared PO-style status vocabulary (also used by Client Orders now).
// Blue = pending · Green = satisfied · Red = trouble
export const STATUS_STYLES = {
  // Pending
  draft: "bg-blue-100 text-blue-800 border-blue-200",
  ordered: "bg-blue-100 text-blue-800 border-blue-200",
  confirmed: "bg-blue-100 text-blue-800 border-blue-200",
  "whc payment pending": "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
  "dropped off": "bg-blue-100 text-blue-800 border-blue-200",
  shipped: "bg-blue-100 text-blue-800 border-blue-200",
  paid: "bg-blue-100 text-blue-800 border-blue-200",
  // Satisfied
  received: "bg-emerald-100 text-emerald-800 border-emerald-200",
  fulfilled: "bg-emerald-100 text-emerald-800 border-emerald-200",
  sold: "bg-emerald-100 text-emerald-800 border-emerald-200",
  promo: "bg-emerald-100 text-emerald-800 border-emerald-200",
  onboarded: "bg-emerald-100 text-emerald-800 border-emerald-200",
  // Trouble
  cancelled: "bg-red-100 text-red-800 border-red-200",
  rma: "bg-red-100 text-red-800 border-red-200",
  lost: "bg-red-100 text-red-800 border-red-200",
  stolen: "bg-red-100 text-red-800 border-red-200",
  damaged: "bg-red-100 text-red-800 border-red-200",
  backorder: "bg-red-100 text-red-800 border-red-200",
  // Legacy client-lifecycle statuses (kept for existing rows)
  new: "bg-blue-100 text-blue-800 border-blue-200",
  "in progress": "bg-amber-100 text-amber-800 border-amber-200",
  "pending order": "bg-amber-100 text-amber-800 border-amber-200",
};

export const ORDER_STATUS_OPTIONS = [
  "draft", "ordered", "dropped off", "shipped", "received", "fulfilled", "sold", "promo",
  "cancelled", "rma", "lost", "stolen", "damaged",
];

export default function StatusPill({ status, testid }) {
  const s = String(status || "").toLowerCase();
  const key = s.startsWith("fulfilled") ? "fulfilled" : s;
  const cls = STATUS_STYLES[key] || "bg-gray-100 text-gray-800 border-gray-200";
  return (
    <span className={`status-pill capitalize ${cls}`} data-testid={testid}>
      {s === "dropped off" ? "Dropped Off" : status}
    </span>
  );
}
